import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {CustomFormsModule} from 'ng2-validation';

import {PasswordValidatorModule} from '../../shared/validators';
import {LoginComponent} from './login.component';
import {ModalModule} from '../../shared/modal/modal.module';

@NgModule({
  imports: [
    CommonModule,
    CustomFormsModule,
    FormsModule,
    FormsModule,
    RouterModule,
    PasswordValidatorModule,
    ModalModule,
  ],
  declarations: [LoginComponent],
  exports: [LoginComponent],
})
export class LoginModule {}



// WEBPACK FOOTER //
// ./src/app/auth/login/login.module.ts